import { Bell } from "lucide-react";
import { Link } from "react-router";
import { useUsers } from "@/api/queries";
import { RelativeTime } from "@/components/common/RelativeTime";
import { UserAvatar } from "@/components/common/UserAvatar";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useShellData } from "./shellData";

export function AdminBell() {
  const { pendingCount, user } = useShellData();
  const pending = useUsers({ status: "pending", limit: 5 }, user?.role === "ADMIN");
  if (user?.role !== "ADMIN") return null;
  const label = pendingCount === 1 ? "1 person waiting for access" : `${pendingCount} people waiting for access`;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon" aria-label={label} className="relative">
          <Bell aria-hidden />
          {pendingCount > 0 && (
            <span
              aria-hidden
              className="absolute -right-0.5 -top-0.5 grid min-w-4 place-items-center rounded-full bg-tone-amber-fg px-1 text-[10px] font-semibold text-background"
            >
              {pendingCount}
            </span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0">
        <div className="border-b px-3 py-2 font-medium">Waiting for access</div>
        {pending.data?.items.length ? (
          <ul>
            {pending.data.items.map((u) => (
              <li key={u.id} className="flex items-center gap-2 border-b px-3 py-2 last:border-b-0">
                <UserAvatar name={u.name} picture={u.picture} size="md" />
                <div className="min-w-0 flex-1">
                  <div className="truncate text-sm">{u.name}</div>
                  <div className="truncate text-xs text-muted-foreground">
                    {u.email} · <RelativeTime iso={u.created_at} />
                  </div>
                </div>
                <Button size="sm" asChild>
                  <Link to={`/admin/users?tab=waiting&admit=${encodeURIComponent(u.id)}`}>Admit</Link>
                </Button>
                <Button size="sm" variant="ghost" asChild>
                  <Link to={`/admin/users?tab=waiting&reject=${encodeURIComponent(u.id)}`}>Reject</Link>
                </Button>
              </li>
            ))}
          </ul>
        ) : (
          <p className="px-3 py-4 text-sm text-muted-foreground">Nobody is waiting for access.</p>
        )}
        <div className="border-t px-3 py-2 text-right">
          <Link className="text-sm text-signal-text" to="/admin/users?tab=waiting">
            View all
          </Link>
        </div>
      </PopoverContent>
    </Popover>
  );
}
